<template>
  <v-app id="inspire">
    <div>
      <div>
        <h2 class="headline">Gift Certificates</h2>
      </div>
      <v-flex class="mb-8">
        <v-layout class="wrap">
          <v-flex class="search-with-btns sm6 xs12">
            <v-text-field
              class="sr-pl-search-field"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
              @input="typing = true"
            ></v-text-field>
          </v-flex>
          <v-layout class="wrap-header-actions sm6 xs12">
            <v-spacer></v-spacer>
            <v-btn
              @click="vEmit({ name: 'CreateGiftCertificate' })"
              color="primary"
              class="mr-0 ml-2"
              :class="{ 'mt-3': $vuetify.breakpoint.xs, 'mt-2': !$vuetify.breakpoint.xs}"
            >
              <v-icon left>add_circle_outline</v-icon>New
            </v-btn>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-layout>
        <v-checkbox
          v-model="tableData.not_used"
          class="mt-0"
          dense
          :true-value="1"
          :false-value="0"
          label="Show Only Unused Certificates"
          @change="initialize(1)"
        ></v-checkbox>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20]}"
          class="elevation-1 table-org my-sticky-last-column-table"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <span v-if="!no_data.includes(item.amount)">{{ `$${item.amount}` }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.amount_used)">{{ `$${item.amount_used}` }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-layout v-if="!no_data.includes(item.client_id) && !no_data.includes(item.client_name)" style="margin-left: -14px;">
                  <v-menu bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="view(`/client/${item.client_id}/show`)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Client Details
                        </v-flex>
                      </v-list-item>
                      <v-list-item
                        @click="view(`/client/${item.client_id}/show`, true)"
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >launch</v-icon
                          >
                          View Client Details in New Tab
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.client_name }}</v-flex>
                  </v-layout>
                </v-layout>
                <span v-else-if="!no_data.includes(item.client_name)">{{ item.client_name }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.expires)">{{ dateFormat(item.expires) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.purchaser_name)">{{ item.purchaser_name }}</span>  
                <em v-else class="grey--text">No data</em>  
              </td>
              <td>
                <span v-if="!no_data.includes(item.client_id) && !no_data.includes(item.client_name)">{{ item.client_name }}</span>
                <span v-else-if="!no_data.includes(item.recipient_name)">{{ item.recipient_name }}</span>
                <em v-else class="grey--text">No data</em>  
              </td>
              <td>
                <span v-if="!no_data.includes(item.reference_number)">{{ item.reference_number }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.description)">{{ item.description }}</span>  
                <em v-else class="grey--text">No data</em>  
              </td>
              <td>
                <v-layout>
                  <v-flex
                    class="action-link pr-2"
                    style="min-width: 60px;"
                    @click="goToCouponView(item.id)"
                  >
                    View
                    <v-icon>visibility</v-icon>
                  </v-flex>
                  <v-flex
                    v-if="!no_data.includes(item) && no_data.includes(item.client_id)"
                    class="action-link"
                    style="min-width: 80px;"
                    @click="vEmit({ name: 'SetClientForGiftCard', data: { action: 'set', ...item } })"
                  >
                    Set Client
                    <v-icon>person_add</v-icon>
                  </v-flex>
                  <v-flex
                    v-if="
                      !no_data.includes(item) &&
                      !no_data.includes(item.client_id) &&
                      no_data.includes(item.description) &&
                      (
                        item.amount_used === '0.00' ||
                        Number(item.amount_used) === 0 ||
                        no_data.includes(item.amount_used)
                      )
                    "
                    class="action-link"
                    style="min-width: 110px;"
                    @click="vEmit({ name: 'SetClientForGiftCard', data: { action: 'change', ...item } })"
                  >
                    Change Client
                    <v-icon>edit</v-icon>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <create-gift-certificate @done="initialize(1)"></create-gift-certificate>
      <set-client-for-gift-card @done="initialize()"></set-client-for-gift-card>
    </div>
  </v-app>
</template>
<script>
import ApiService from "@/common/api.service";
import { mapActions } from 'vuex'
import CreateGiftCertificate from "./CreateGiftCertificate";
import SetClientForGiftCard from "./SetClientForGiftCard";

export default {
  name: "GiftCertificates",
  components: {
    CreateGiftCertificate,
    SetClientForGiftCard
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    clients: [],
    loadingClients: false,
    preparedData: {},
    coupon_types: [
      { type: "Percent", slug: "percent" },
      { type: "Amount", slug: "amount" }
    ],
    durations: [
      { text: "Forever", value: "forever" },
      { text: "Once", value: "once" },
      { text: "Multiple Billing Intervals", value: "repeating" }
    ],
    coupon: {},
    deleteCouponDialog: false,
    deleteCouponLoading: false,
    totalItems: 0,
    items: [],
    loading: false,
    options: {},
    valid: true,
    search: "",
    headers: [
      { text: "Amount", value: "amount", sort_column: 1 },
      { text: "Amount Used", value: "amount_used", sortable: false },
      { text: "Client", value: "client", sort_column: 3 },
      { text: "Expires", value: "redeem_by", sort_column: 0, width: '105px' },
      { text: "Purchaser Name", value: "purchaser_name", sortable: false },
      { text: "Recipient Name", value: "recipient_name", sortable: false },
      { text: "Reference Number", value: "reference_number", sortable: false },
      { text: "Description", value: "description", sortable: false },
      // { text: "Status", value: "status", sort_column: 2 },
      { text: "Actions", value: "actions", sortable: false }
    ],
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "desc"
    },
    form_model: true,

    makeDefaultDialog: false,
    makeDefaultLoading: false,
    defaultCouponData: {},

    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize()
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false
      if (this.draw !== this.tableData.draw) {
        this.initialize(1)
      }
    }, 1000)
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize(setPage) {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column;
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;
      this.tableData.page = page;
      this.tableData.search = this.search;

      if (this.tableData.not_used === 0) {
        delete this.tableData.not_used
      }

      this.tableData.draw++;
      this.draw = this.tableData.draw;

      ApiService.get("/gift_cards", this.tableData)
        .then(response => {
          this.draw++
          let data = response.data;
          this.items = data.certificates.data;
          this.totalItems = data.certificates.total;
          if (setPage) { this.options.page = setPage }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        })
    },

    //Go to Coupon Individual View
    goToCouponView(id) {
      this.$router.push(`/gift_certificate/${id}/show`);
    },
    dateFormat(date) {
        return moment(date).format("YYYY-MM-DD");
    },
    view(link, newTab = false) {
      if (newTab) {
        let routeData = this.$router.resolve({ path: link });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push(link);
      }
    },
    makeCapitalFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    }
  }
};
</script>
<style>
/*New Coupon Dialog*/
.wrap-dialog-elements {
  width: 100%;
  float: left;
}
.date-picker-dialog {
  margin-bottom: 20px;
}
</style>
